import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { PetitumRevisione } from '../../../models/petitum-revisione';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { FondoRischiAddRevisioneComponent } from './sezione-economica-fondo-rischi-add-revisione.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-fondo-rischi-add-revisione]',
  templateUrl: 'sezione-economica-mod-fondo-rischi-add-revisione.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ModFondoRischiAddRevisioneComponent {
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  isFs: boolean = PropertiesSettings.ID_TENANTS_FS();
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formFondoRischiRevisione') formFondoRischiRevisione: FondoRischiAddRevisioneComponent;

  inizializza(sezione: SezioneEconomica, petitumRevisione: PetitumRevisione, fascicolo: FascicoloFull, urlInsert: string, urlSezioneControparti: string = '', idSezioneControparti: string = '', isPercentualeSoccombenza: boolean = false, idSezioneClassificazioni: string = '') {
    openModal('modaleFondoRischiRevisioneAdd');
    this.formFondoRischiRevisione.inizializza(sezione, petitumRevisione, fascicolo, urlInsert, urlSezioneControparti, idSezioneControparti, isPercentualeSoccombenza);
  }

  createForm() {
    this.formFondoRischiRevisione.createForm();
  }

  manageModal(sezioneEconomica: SezioneEconomica) {
      closeModal('modaleFondoRischiRevisioneAdd');
      this.onReturn.emit(sezioneEconomica);
  }

  closeModal() {
    closeModal('modaleFondoRischiRevisioneAdd');
  }
}
